import { AskFetch } from '@/shared/AskFetch'

export default AskFetch
